import React from 'react';
import TaxBillIssuedInfo from '../../components/taxIssuedmng/TaxBillIssuedInfo';

const TaxBillIssuedInfoContainer = ({ taxbill }) => {
  return <TaxBillIssuedInfo taxbill={taxbill} />
};

export default TaxBillIssuedInfoContainer;
